import React from 'react';
import Button, { ButtonType } from 'legacy/common/components/button/Button';

type CreateOfferActionsProps = {
  handleCreateOffer: () => void;
};

const CreateOfferActions: React.FC<CreateOfferActionsProps> = ({
  handleCreateOffer
}) => (
  <>
    <div className="w-full bg-white fixed bottom-0 left-0 p-4 z-10 border-t pb-12 md:pb-4">
      <div className="w-full md:w-[343px] mx-auto">
        <div className="flex gap-4">
          <Button type={ButtonType.Primary} onClick={handleCreateOffer}>
            <div className="flex items-center justify-center">Create offer</div>
          </Button>
        </div>
      </div>
    </div>
  </>
);

export default CreateOfferActions;
